import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const AccountMembershipTaskDefinition: TaskDefinition<'BankingAccountMembership'> = {
  taskableTypename: 'BankingAccountMembership',
  getTitle: () => {
    return i18n.t('tasks.inbox.titles.account_membership')
  },
  getUrl: ({ info, navigation, status }) => {
    if (!info.id) return null

    const accountId = info.account?.id
    if (!accountId) return null

    if (status === 'done') {
      return navigation.finance.banking.accounts.accountId.fullPath({ id: String(accountId) })
    }

    const accountsPath = navigation.finance.banking.accounts.fullPath()
    return `${accountsPath}?setup_membership=${info.id}`
  },
}
